import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from "./layout/app.layout.component";

@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: '', redirectTo: 'amministrazione/insegne', pathMatch: 'full' },
            {
                path: '', component: AppLayoutComponent,
                children: [
                    { path: 'amministrazione', loadChildren: () => import('./features/amministrazione/amministrazione.module').then(m => m.AmministrazioneModule) },
                ]
            },
            { path: 'base', loadChildren: () => import('./features/base/base.module').then(m => m.BaseModule) },
            { path: '**', redirectTo: '/base/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
